import React, { Component, PureComponent } from 'react'
import { Link } from 'react-router-dom'
import { Icon } from 'semantic-ui-react'
import DatatableExport from './export'

export default function DataTableHeader(props) {
  let { search = '', onSearch, actions = {}, onAction, texts = {}, crud = false } = props

  return (
    <div className="datatable-header">
      <div className="datatable-header-left">
        <div className="datatable-header-actions">
          <button
            className="datatable-header-action datatable-header-action--icon"
            onClick={e => e.preventDefault() & onAction('refetch')}>
            <Icon name="repeat" />
          </button>
          {crud ? (
            <button className="datatable-header-action" onClick={e => e.preventDefault() & onAction('create')}>
              <Icon name="plus" />
              <span>{texts.createButton || 'Luo uusi'}</span>
            </button>
          ) : null}
          {actions.map(({ text, icon, action, href = false }, key) => {
            if (href)
              return (
                <Link to={href} key={key} className="datatable-header-action">
                  {icon ? <Icon name={icon} /> : null}
                  <span>{text}</span>
                </Link>
              )

            return (
              <button
                className="datatable-header-action"
                key={key}
                onClick={e => (e.preventDefault() & (typeof action === 'function') ? action() : onAction(action))}>
                {icon ? <Icon name={icon} /> : null}
                <span>{text}</span>
              </button>
            )
          })}
        </div>
      </div>
      <div className="datatable-header-right">
        <div className="datatable-search">
          <input
            type="text"
            id="datatable-search"
            placeholder="Hae..."
            value={search}
            onChange={e => onSearch(e.target.value)}
          />
          <label htmlFor="datatable-search">
            <Icon name="search" />
          </label>
          {search.length ? (
            <button className="datatable-search-empty" onClick={e => e.preventDefault() & onSearch('')}>
              <Icon name="close" />
            </button>
          ) : null}
        </div>
        <DatatableExport {...props} />
      </div>
    </div>
  )
}
